module.exports = __webpack_public_path__ + "static/media/warning.06bb24e3.svg";